import React, { useEffect, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Card, CardBody, Col, Container, Row, Button, CardText, CardTitle, ButtonGroup, Input, FormGroup, Label } from 'reactstrap';
import notify from '../../../custom/helpers/Notify';
import { pageState, themeTypeState } from '../../../state/GlobalState';
import { cloneDeep, get, set } from 'lodash';
import Flatpickr from "react-flatpickr"
import { mergeOperationalDateCaps } from '../../../utils/flatpickrOperational';
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import { getDataListRequest, exportDataRequest, getAirlinesListRequest } from '../../../api/controller/BagReportController';
import { getUserListRequest } from '../../../api/controller/CaseFileController';
import { filtersDefault, bagReportDataStructureState as dataStructureState, bagReportListState as dataListState, bagReportAirlineState } from './state';
import { Loader } from '../../../custom/components/Loader';
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import moment from "moment";

const BagsReport = () => {

  const model = 'Bag Report'
  const models = 'Bags Report'

  const defaultColDef = {
    sortable: true,
    editable: false,
  }
  const [dataList, setDataList] = useRecoilState(dataListState);
  // eslint-disable-next-line
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridApi, _setGridApi] = useState(null);
  const gridApiRef = useRef(gridApi)
  const setGridApi = data => {
    gridApiRef.current = data;
    _setGridApi(data)
  }
  const setPage = useSetRecoilState(pageState)
  const [searchSeq, setSearchSeq] = useState(0)
  const [hasSearched, setHasSearched] = useState(false)
  const [tableLoading, setTableLoading] = useState(false)
  const themeType = useRecoilValue(themeTypeState)
  const [mobileSearchFilter, setMobileSearchFilter] = useState('')
  const [searchValue, setSearchValue] = useState('')

  const [counts, setCounts] = useState({})

  const [filters, setFilters] = useState(filtersDefault)
  const dataStructure = useRecoilValue(dataStructureState)
  const [ovf, _setOvf] = useState(false);
  const ovfRef = useRef(ovf);
  const setOvf = data => {
    ovfRef.current = data;
    _setOvf(data);
  }
  const [xsFData, setXsFData] = useState([])
  const [xsPageSize] = useState(10)
  const [xsCurrentPage, setXsCurrentPage] = useState(1)
  const [xsMaxPage, setXsMaxPage] = useState(1)
  const [airlines, _setAirlines] = useRecoilState(bagReportAirlineState)
  const airlinesRef = useRef([])
  const setAirlines = data => {
    airlinesRef.current = data;
    _setAirlines(data)
  }
  const [staffUsers, _setStaffUsers] = useState([])
  const staffUsersRef = useRef([])
  const setStaffUsers = data => {
    staffUsersRef.current = data
    _setStaffUsers(data)
  }
  const withFilterLists = (f) => {
    if (f.label === 'Airline') {
      return { ...f, list: [...[{ label: 'All Airlines', value: 'All' }, ...airlinesRef.current]] }
    }
    if (f.name === 'CreatedByUserId') {
      return { ...f, list: [...[{ label: 'All staff', value: 'All' }, ...staffUsersRef.current]] }
    }
    return f
  }

  useEffect(() => {
    setPage((models.charAt(0).toLowerCase() + models.slice(1)).split(" ").join(""))
  }, [setPage, models])

  useEffect(() => {
    async function fetchAirlines() {
      const response = await getAirlinesListRequest()
      if (response && response.Status !== 'error') {
        setAirlines([...new Set(response.data)].map(airline => ({ value: airline, label: airline })))
      } else {
        notify({ status: 'error', message: response.Message })
      }
    }
    fetchAirlines()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    async function fetchStaff() {
      const response = await getUserListRequest({})
      if (response && response.Status !== 'error') {
        setStaffUsers(response.data.map((u) => ({ value: u.id, label: u.name })))
      } else if (response) {
        notify({ status: 'error', message: response.Message })
      }
    }
    fetchStaff()
  }, [])

  useEffect(() => {
    setFilters((prev) => prev.map((filter) => {
      if (filter.label === 'Airline') {
        return { ...filter, list: [...[{ label: 'All Airlines', value: 'All' }, ...airlines]] }
      }
      if (filter.name === 'CreatedByUserId') {
        return { ...filter, list: [...[{ label: 'All staff', value: 'All' }, ...staffUsers]] }
      }
      return filter
    }))
  }, [airlines, staffUsers])

  useEffect(() => {
    if (searchSeq === 0) {
      return
    }
    let cancelled = false
    async function fetchData() {
      setTableLoading(true)
      setDataList([])
      let postData = {}
      try {
        filters.forEach((filter) => {
          if (filter.value) {
            set(postData, filter.name || filter.label.replace(/ /g, ''), filter.type === "select" ? filter.value.value : filter.value)
          }
        })
        set(postData, 'Type', 'All')
        if (ovf) {
          set(postData, 'SearchQuery', searchValue)
        }
        const response = await getDataListRequest(postData);
        if (cancelled) {
          return
        }
        if (response && response.Status !== 'error') {
          setDataList(response.data)
          setCounts(response.counts || {})
          setHasSearched(true)
          response.ovf ? setOvf(true) : setOvf(false)
        } else {
          notify({ status: 'error', message: response.Message })
        }
      } finally {
        if (!cancelled) {
          setTableLoading(false)
        }
      }
    }
    fetchData()
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchSeq])

  const runSearch = () => {
    let ok = true
    filters.forEach((filter) => {
      ok = !(filter.value.length === 0 && filter.required) && ok
    })
    if (!ok) {
      notify({ status: 'warning', message: 'Please select a period.' })
      return
    }
    setSearchSeq((s) => s + 1)
  }

  const handleExport = async () => {
    let fetch = true
    let postData = {}
    if (filters.length > 0) {
      filters.forEach((filter) => {
        fetch = filter.value.length === 0 && filter.required ? false : fetch
        if (filter.value) {
          set(postData, filter.name || filter.label.replace(/ /g, ''), filter.type === "select" ? filter.value.value : filter.value)
        }
      })
    }
    set(postData, 'Type', 'All')
    if (ovf) {
      set(postData, 'SearchQuery', searchValue)
    }
    if (!fetch) {
      notify({ status: 'warning', message: 'Please select a period.' })
      return
    }
    const response = await exportDataRequest(postData)
    if (response && response.Status !== 'error') {
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(new Blob([response]))
      link.setAttribute('download', `BagsReport-${moment().format("YYYY-MM-DD-HHmm")}.xlsx`)
      document.body.appendChild(link)
      link.click()
    }
  }

  useEffect(() => {
    return () => {
      setDataList([])
    }
    // eslint-disable-next-line
  }, [])

  const getFN = (val) => {
    return val.field || val.label.replace(/ /g, '_').toLowerCase()
  }

  const valueGetter = (data, input) => {
    if (input.type === 'checkbox') {
      return (parseInt(data[getFN(input)]) === 1 || data[getFN(input)] === true) ? "Yes" : ((parseInt(data[getFN(input)]) === 0 || data[getFN(input)] === false) ? "No" : "")
    } else if (input.type === 'switch') {
      return (parseInt(data[getFN(input)]) === 1 || data[getFN(input)] === true) ? (input.list && input.list[0] ? input.list[0] : "Yes") : ((parseInt(data[getFN(input)]) === 0 || data[getFN(input)] === false) ? (input.list && input.list[1] ? input.list[1] : "No") : "")
    } else if ((input.type === 'select' || input.type === 'multiselect' || input.type === 'nestedselect') && !input.rootValue) {
      return data[getFN(input)] ? data[getFN(input)][input.subFields?.label || "name"] : ""
    } else if (input.type === 'datepicker' && input.table?.dateFormat) {
      return data[getFN(input)] ? moment(data[getFN(input)]).format(input.table.dateFormat) : null
    } else {
      return data[getFN(input)]
    }
  }

  let columns = [...dataStructure.filter((val) => val.order?.table).sort((a, b) => (a.order?.table > b.order?.table ? 1 : -1)).map((val) => (
    {
      headerName: val.tableHeader || val.label,
      field: ((val.field || val.label.replace(/ /g, '_').toLowerCase()).replace(/\./g, '') + (val.subFields || (val.type === "select" && !val.rootValue) ? val.subFields?.label || val.subFields?.name || "name" : "")).replace(/\./g, ''),
      filter: val.type === 'number' ? 'agNumberColumnFilter' : (val.type === 'datepicker' ? 'agDateColumnFilter' : 'agTextColumnFilter'),
      valueGetter: (params) => valueGetter(params?.data || params, val),
      cellRendererFramework: (params) => val.table?.customRender ? val.table.customRender(valueGetter(params?.data || params, val), params) : valueGetter(params?.data || params, val),
      maxWidth: val.table?.maxWidth || null,
      minWidth: val.table?.minWidth || null,
      ...(val.table?.flex != null ? { flex: val.table.flex } : {}),
    })),
  ]

  const data = dataList?.map((row) => {
    let tempRow = cloneDeep(row)
    dataStructure.filter((input) => input.order?.table).forEach((input) => {
      const field = input.subFields || (input.type === "select" && !input.rootValue) ? (input.subFields?.label || input.subFields?.name || input.type === "select" ? ((input.field || input.label.replace(/ /g, '_').toLowerCase()) + "." + (input.subFields?.label || input.subFields?.name || "name")) : (input.field || input.label.replace(/ /g, '_').toLowerCase())) : (input.field || input.label.replace(/ /g, '_').toLowerCase());
      let temp = get(tempRow, field)
      if (!(temp === false || temp === 0)) {
        temp = temp || input.tableDefault || ""
      }
      set(tempRow, field.replace(/\./g, ''), temp)
    })
    return tempRow
  })

  const changeFilter = (e, k) => {
    if (filters[k].type === "dateRange") {
      const els = document.getElementsByClassName("flatpickr-calendar")
      let visible = false
      Array.from(els).forEach((e) => {
        if (e.checkVisibility()) {
          visible = true
        }
      })
      if (e.split(" to ").length > 1) {
        setFilters(filters.map((f, key) => {
          const next = key !== k ? f : { ...f, value: e.split(" to ") }
          return withFilterLists(next)
        }))
      } else if (!visible) {
        setFilters(filters.map((f, key) => {
          const next = key !== k ? f : { ...f, value: [e, e] }
          return withFilterLists(next)
        }))
      }
    } else if (filters[k].type === "date") {
      setFilters(filters.map((f, key) => {
        const next = key !== k ? f : { ...f, value: e }
        return withFilterLists(next)
      }))
    } else if (filters[k].type === "select") {
      setFilters(filters.map((f, key) => {
        const next = key !== k ? f : { ...f, value: f.list.filter((o) => (parseInt(o.value) === parseInt(e.value) || o.value === e.value))[0] }
        return withFilterLists(next)
      }))
    }
  }

  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if (params.api) {
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', function () {
        setTimeout(function () {
          params.api.sizeColumnsToFit();
        });
      });
      params.api.sizeColumnsToFit();
    }
  };
  useEffect(() => {
    if (!ovf) {
      setXsFData(data.filter(item => {
        let match = true
        if (mobileSearchFilter.length > 0) {
          let filters = mobileSearchFilter.split(" ")
          filters.filter(f => f.length > 0).forEach(filter => {
            let innerMatch = false
            columns.forEach((column) => {
              const raw = column.valueGetter(item)
              const display = raw != null && raw !== '' ? String(raw) : ''
              if (display.toLowerCase().indexOf(String(filter).toLowerCase()) >= 0) {
                innerMatch = true
              }
            })
            if (!innerMatch) {
              match = false
            }
          })
        }
        return match
      }))
    } else {
      setXsFData(data)
    }
    // eslint-disable-next-line
  }, [dataList, mobileSearchFilter])
  useEffect(() => {
    if (!ovf) {
      setSearchValue(mobileSearchFilter)
    }
    // eslint-disable-next-line
  }, [mobileSearchFilter])

  useEffect(() => {
    let maxPages = Math.ceil(xsFData.length / xsPageSize)
    if (maxPages !== xsMaxPage) {
      setXsCurrentPage(1)
    }
    setXsMaxPage(maxPages)
    // eslint-disable-next-line
  }, [xsFData])

  const periodFilters = filters.filter((f) => f.type === 'dateRange')
  const otherFilters = filters.filter((f) => f.type !== 'dateRange')

  return (
    <React.Fragment>
      <div
        className={`page-content pb-4${themeType !== 'dark' ? ' bg-white' : ''}`}
        style={themeType !== 'dark' ? { minHeight: 'calc(100vh - 5rem)' } : undefined}
      >
        <Container fluid>
          <Row className="mb-4 pt-2 align-items-center">
            <Col xs={12}>
              <h3 className="mb-0">{model}</h3>
            </Col>
          </Row>
          {filters && filters.length > 0 ? (
            <Card className={`border shadow-sm mb-4${themeType !== 'dark' ? '' : ' border-secondary'}`}>
              <CardBody className="p-4">
                <Row className="g-4">
                  {periodFilters.map((filter, key) => {
                    const i = filters.indexOf(filter)
                    return (
                      <Col xs={12} md={8} lg={6} key={`period-${key}`}>
                        <FormGroup className="mb-0">
                          <Label className="form-label fw-semibold mb-2">
                            {filter.label}
                            {filter.required ? <span className="text-danger"> *</span> : null}
                          </Label>
                          <Flatpickr onChange={(_, e) => changeFilter(e, i)} placeholder="Select date range..." options={mergeOperationalDateCaps({ mode: 'range', altInput: true, defaultDate: filter.value })} value={filter.value} className="form-control d-block" />
                        </FormGroup>
                      </Col>
                    )
                  })}
                </Row>
                <Row className="g-4 mt-1">
                  {otherFilters.map((filter) => {
                    const key = filters.indexOf(filter)
                    return (
                      <Col xs={12} sm={6} xl={3} key={filter.name || filter.label}>
                        <FormGroup className="mb-0">
                          <Label className="form-label fw-semibold mb-2">
                            {filter.label}
                            {filter.required ? <span className="text-danger"> *</span> : null}
                          </Label>
                          {filter.type === "date" ? (
                            <Flatpickr onChange={(_, e) => changeFilter(e, key)} placeholder="Select date..." options={mergeOperationalDateCaps({ altInput: true, defaultDate: filter.value })} value={filter.value} className="form-control d-block" />
                          ) : null}
                          {filter.type === "select" ? (
                            <div className="react-select-case-report">
                              <Select
                                onChange={(e) => changeFilter(e, key)}
                                placeholder="Select..."
                                options={filter.list}
                                value={filter.value}
                                classNamePrefix="rs"
                              />
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>
                    )
                  })}
                </Row>
                <Row className="mt-4 pt-3 border-top">
                  <Col xs={12} className="d-flex justify-content-end flex-wrap align-items-center gap-2">
                    <Button color="info" className="waves-effect waves-light d-inline-flex align-items-center justify-content-center gap-1 px-3 py-2" type="button" onClick={handleExport}>
                      <i className="mdi mdi-download font-size-16 align-middle" aria-hidden />
                      <span>Export</span>
                    </Button>
                    <Button color="primary" className="waves-effect waves-light d-inline-flex align-items-center justify-content-center gap-1 px-3 py-2" type="button" onClick={runSearch}>
                      <i className="mdi mdi-eye font-size-16 align-middle" aria-hidden />
                      <span>Show</span>
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          ) : null}
          <Row className="mt-3">
            <Col className="col-12">
              {hasSearched ? (
                <>
                  <Card className='d-none d-md-block'>
                    <CardBody>
                      <Loader loading={tableLoading} />
                      <Row>
                        <Col xs={12} sm={6} md={4}>
                          <div style={{ display: 'flex', justifyContent: 'left' }}>
                            <input value={searchValue} onKeyPress={(e) => {
                              if (e.key === 'Enter' && ovf) {
                                runSearch()
                              }
                            }} type="text" className="form-control" onChange={(e) => {
                              if (!ovf) {
                                gridApiRef.current?.setQuickFilter(e.target.value)
                              }
                              setSearchValue(e.target.value)
                            }} placeholder="Search..." style={{ maxWidth: "400px", marginBottom: "15px" }} />
                            {ovf ? (
                              <>&nbsp;&nbsp;&nbsp;<Button style={{ maxHeight: '38px' }} color='primary' className='btn-sm waves-effect waves-light' onClick={runSearch}>Show All</Button></>
                            ) : null}
                          </div>
                        </Col>
                        <Col xs={12} sm={6} md={8}>
                          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            {counts.AHL ? <><span className="badge badge-soft-warning font-size-16 mr-1">AHL: {counts.AHL}</span>&nbsp;</> : null}
                            {counts.DPR ? <><span className="badge badge-soft-warning font-size-16 mr-1">DPR: {counts.DPR}</span>&nbsp;</> : null}
                            {counts.OHD ? <><span className="badge badge-soft-warning font-size-16 mr-1">OHD: {counts.OHD}</span>&nbsp;</> : null}
                            {counts.UNCLAIMED ? <><span className="badge badge-soft-warning font-size-16 mr-1">UNCLAIMED: {counts.UNCLAIMED}</span>&nbsp;</> : null}
                            {counts.CLAIMS ? <><span className="badge badge-soft-warning font-size-16 mr-1">CLAIMS: {counts.CLAIMS}</span>&nbsp;</> : null}
                          </div>
                        </Col>
                      </Row>
                      <div className={themeType === 'dark' ? "ag-theme-alpine-dark" : "ag-theme-alpine"} style={{ height: '650px' }}>
                        <AgGridReact
                          defaultColDef={defaultColDef}
                          onGridReady={onGridReady}
                          rowHeight={55}
                          rowStyle={{ border: 'none' }}
                          animateRows={true}
                          pagination={true}
                          paginationPageSize={10}
                          rowData={data}
                          getRowNodeId={(data) => data.id}
                          columnDefs={columns}
                          rowSelection="none"
                        >
                        </AgGridReact>
                      </div>
                    </CardBody>
                  </Card>
                  <div className="d-block d-md-none mt-2">
                    <Loader loading={tableLoading} />
                    <div className="d-block d-md-none" style={{ display: 'flex', justifyContent: 'left' }}>
                      <div style={{ display: 'flex', justifyContent: 'left' }}>
                        <input value={mobileSearchFilter} type="text" className="form-control" onKeyPress={(e) => {
                          if (e.key === 'Enter' && ovf) {
                            runSearch()
                          }
                        }} onChange={(e) => {
                          setMobileSearchFilter(e.target.value)
                        }} placeholder="Search..." style={{ maxWidth: "315px", marginBottom: "15px" }} />
                        {ovf ? (
                          <>&nbsp;&nbsp;&nbsp;<Button style={{ maxHeight: '38px', minWidth: '58px' }} color='primary' className='btn-sm waves-effect waves-light' onClick={runSearch}>Show</Button></>
                        ) : null}
                      </div>
                    </div>
                    {xsFData.slice(((xsCurrentPage - 1) * xsPageSize), (xsCurrentPage * xsPageSize)).map((item, key) => (
                      <Card key={key} className='border border-primary'>
                        <CardTitle className='text-center bg-primary pt-2 pb-2 text-white'>{item[columns[0]?.field]}</CardTitle>
                        <CardBody className='pt-0 pb-0'>
                          {columns.map((column, ck) => (
                            ck > 0 ? <CardText key={ck} className="mb-2"><span style={{ fontWeight: 600 }}>{column.headerName}: </span><span className={themeType === 'dark' ? 'text-white' : 'text-primary'}>{column.valueGetter(item)}</span></CardText> : null
                          ))}
                        </CardBody>
                        <ButtonGroup>
                        </ButtonGroup>
                      </Card>
                    ))}
                    <ButtonGroup style={{ display: "flex" }}>
                      <Button disabled={xsCurrentPage <= 1} onClick={() => setXsCurrentPage(1)} color='info' className='btn-md waves-effect waves-light' style={{ marginLeft: '2px' }}>
                        <i className='mdi mdi-chevron-double-left d-block font-size-16'></i>
                      </Button>
                      <Button disabled={xsCurrentPage <= 1} onClick={() => setXsCurrentPage((c) => --c)} color='info' className='btn-md waves-effect waves-light' style={{ marginLeft: '2px' }}>
                        <i className='mdi mdi-chevron-left d-block font-size-16'></i>
                      </Button>
                      <Button color='info' className='btn-md waves-effect waves-light' style={{ marginLeft: '2px' }}>
                        <Input style={{ maxWidth: "50px" }} type="text" value={xsCurrentPage} onClick={(e) => e.target.setSelectionRange(0, e.target.value.length)} onChange={(e) => {
                          if (parseInt(e.target.value) > 0 && parseInt(e.target.value) <= xsMaxPage) {
                            e.target.blur()
                            setXsCurrentPage(parseInt(e.target.value))
                          }
                        }} />
                      </Button>
                      <Button color='info' className='btn-md waves-effect waves-light'>
                        of
                      </Button>
                      <Button color='info' className='btn-md waves-effect waves-light'>
                        {xsMaxPage}
                      </Button>

                      <Button disabled={xsCurrentPage >= xsMaxPage} onClick={() => setXsCurrentPage((c) => ++c)} color='info' className='btn-md waves-effect waves-light' style={{ marginLeft: '2px' }}>
                        <i className='mdi mdi-chevron-right d-block font-size-16'></i>
                      </Button>
                      <Button disabled={xsCurrentPage >= xsMaxPage} onClick={() => setXsCurrentPage(xsMaxPage)} color='info' className='btn-md waves-effect waves-light' style={{ marginLeft: '2px' }}>
                        <i className='mdi mdi-chevron-double-right d-block font-size-16'></i>
                      </Button>
                    </ButtonGroup>
                  </div>
                </>
              ) : null}
            </Col>
          </Row>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(BagsReport);
